"use client";

export const BrowserTimeZone = () => {
  return Intl.DateTimeFormat().resolvedOptions().timeZone;
};

export const BrowserTimeOffset = () => {
  const mins = -new Date().getTimezoneOffset();
  const hrs =
    mins < 0
      ? `0${Math.ceil(mins / 60)}`.slice(-2)
      : "+" + `0${Math.floor(mins / 60)}`.slice(-2);
  return `${hrs}:${mins % 60}`;
};
